// Feature flags. A flag is on for everyone when NEXT_PUBLIC_FF_<NAME>=1 is set at build time,
// or for one browser: visit any page with ?ff=<name> (and ?ff=-<name> to turn it off again).

const KEY = "paldeck:flags";
const ENV: Record<string, string | undefined> = {
  ai: process.env.NEXT_PUBLIC_FF_AI,
};

function stored(): string[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "[]") as string[];
  } catch {
    return [];
  }
}

/** Apply ?ff=name / ?ff=-name from the URL, then return whether `name` is on. Client-only. */
export function flagEnabled(name: string): boolean {
  if (ENV[name] === "1") return true;
  let list = stored();
  try {
    const p = new URLSearchParams(window.location.search).getAll("ff").flatMap((v) => v.split(","));
    if (p.length) {
      for (const f of p) {
        if (f.startsWith("-")) list = list.filter((x) => x !== f.slice(1));
        else if (!list.includes(f)) list.push(f);
      }
      localStorage.setItem(KEY, JSON.stringify(list));
    }
  } catch {
    /* storage blocked */
  }
  return list.includes(name);
}
